export default "__VITE_ASSET__DQ21sJWz__"